import React, { useState } from "react";
import human from "../assets/human.png";
import save from "../assets/saveicon.png";
import delte from "../assets/deleteicon.png";
import fluent from "../assets/fluentarrow.png";
import "../App.css";

const MainTable = ({filterby,tableData}) => {
    const [entriesPerPage, setEntriesPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [isChecked,setISChecked]=useState(false)
    const totalEntries = 5; // Adjust if dynamic data is used
    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    return (
        <div className="w-full max-w-full overflow-x-auto custom-scrollbar">
            <table className="w-full min-w-[1000px] border-collapse">
                <thead>
                    <tr className="border border-gray-300 text-[#900]">
                        <th className="p-3 w-[%]">
                            <div className="flex justify-center items-center">
                            <input
                                onChange={()=>setISChecked(!isChecked)}
  type="checkbox"
  className={`w-4 h-4 form-checkbox ${!isChecked?"appearance-none":''} accent-[#900] border-2 border-[#900]`}
/>
                            </div>
                        </th>
                        <th className="p-3 pl-9 w-[20%] text-start">Employee</th>
                        <th className="p-3 w-[10%] text-start">Job Code</th>
                        <th className="p-3 w-[15%] text-start">Cost Code</th>
                        <th className="p-3 w-[10%] text-start">Clock In</th>
                        <th className="p-3 w-[10%] text-start">Clock Out</th>
                        <th className="p-3 w-[7%] text-start">Break</th>
                        <th className="p-3 w-[9%] text-start">Per Diem ($)</th>
                        <th className="p-3 w-[7%] text-start">Total Hours</th>
                        <th className="p-3 w-[20%] text-start">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: 5 }).map((_, index) => (<>
                    {filterby==='Classification'?<>
                        <tr key={index} className="border border-gray-300 bg-[#FEE2E2] ">
                            <td>
                            <div className="flex justify-center items-center">
                                <input
                                onChange={()=>setISChecked(!isChecked)}
  type="checkbox"
  className={`w-4 h-4 form-checkbox ${!isChecked?"appearance-none":''} accent-[#900] border-2 border-[#900]`}
/>

                                </div>

                            </td>
                            <td>

                            <div className="font-semibold text-start text-[#991B1B]">
                                        Electrical Engineer
                            </div>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            </tr>
                    </>:
                        <tr key={index} className="border border-gray-300">
                            <td className="p-3">
                                <div className="flex justify-center items-center">
                                <input
                                onChange={()=>setISChecked(!isChecked)}
  type="checkbox"
  className={`w-4 h-4 form-checkbox ${!isChecked?"appearance-none":''} accent-[#900] border-2 border-[#900]`}
/>

                                </div>
                            </td>
                            <td className="p-3">
                                <div className="flex items-center justify-center gap-2">
                                    <img src={human} alt="Employee" />
                                    <div className="whitespace-normal break-words">
                                        <div className="font-semibold text-start">RUBEN BELTRAN{index + 1}</div>
                                        <div className="flex gap-2 text-sm text-[#6B7280]">
                                            <div>603</div>
                                            <div>• Electrical Superintendent</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="p-3">
                                <div className="flex items-center justify-center w-[96px] h-[28px] border border-[#E4E4E7] bg-white rounded-[6px]">
                                    <div className="text-gray-900 p-2">1002</div>
                                </div>
                                <div className="text-sm text-start text-[#6B7280] break-words whitespace-normal">
                                    Wiring for security system
                                </div>
                            </td>
                            <td className="p-3">
                                <div>
                                    <div className="flex items-center justify-center w-[96px] h-[28px] border border-[#E4E4E7] bg-white rounded-[6px]">
                                        <div className="text-gray-900 p-2">1002</div>
                                    </div>
                                    <div className="text-sm text-start text-[#6B7280] break-words whitespace-normal">
                                        Lighting Control Panels & Junction Boxes
                                    </div>
                                </div>
                            </td>
                            <td className="p-3">
                                <div className="flex items-center justify-center w-[96px] h-[28px] border border-[#E4E4E7] bg-white rounded-[6px] whitespace-nowrap">
                                    <div className="text-gray-900 p-2 text-sm">5:45 AM</div>
                                </div>
                            </td>
                            <td className="p-3">
                                <div className="flex items-center justify-center w-[96px] h-[28px] border border-[#E4E4E7] bg-white rounded-[6px] whitespace-nowrap">
                                    <div className="text-gray-900 p-2 text-sm">7:45 PM</div>
                                </div>
                            </td>
                            <td className="p-3">
                                <div className="flex items-center justify-center w-[56px] h-[28px] border border-[#E4E4E7] bg-white rounded-[6px]">
                                    <div className="text-gray-900 p-2 text-sm">30</div>
                                </div>
                            </td>
                            <td className="p-3">
                                <div className="flex items-center justify-center w-[56px] h-[28px] border border-[#E4E4E7] bg-white rounded-[6px]">
                                    <div className="text-gray-900 p-2 text-sm">50</div>
                                </div>
                            </td>
                            <td className="p-3">
                                <div className="flex items-center justify-center w-[56px] h-[28px] border border-[#E4E4E7] bg-white rounded-[6px]">
                                    <div className="text-gray-900 p-2 text-sm">8</div>
                                </div>
                            </td>
                            <td className="p-3">
                                <div className="flex items-center gap-3">
                                    <img src={save} className="w-5 h-5 object-contain" alt="Save" />
                                    <img src={fluent} className="w-5 h-5 object-contain" alt="Fluent" />
                                    <img src={delte} className="w-5 h-5 object-contain" alt="Delete" />
                                </div>
                            </td>
                        </tr>}
                        </>
                    ))}
                </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="flex justify-between items-center p-4 text-gray-700">
                {/* Left: Showing Entries */}
                <div className="flex items-center space-x-2">
                    <span>Showing 1-{entriesPerPage} of {totalEntries} entries</span>
                    <select
                        value={entriesPerPage}
                        onChange={(e) => setEntriesPerPage(parseInt(e.target.value))}
                        className="border cursor-pointer border-gray-300 p-1 rounded-md bg-white text-gray-700"
                    >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                    </select>
                    <span>per page</span>
                </div>

                {/* Right: Pagination */}
                <div className="flex flex-col  items-center justify-center gap-4">
 <div className="flex items-center space-x-3">
                    <button 
                        className=" bg-white cursor-pointer text-[#000] " 
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                    >
                        {"< Previous"}
                    </button>
                    <div>
<span className="px-3 py-1 border text-[#000] border-gray-300 rounded-md">{currentPage}</span>

                    </div>
                    
                    <button 
                        className="  bg-white cursor-pointer text-[#000] " 
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(currentPage + 1)}
                    >
                        {"Next >"}
                    </button>
                </div>
<div>page 1 of 8</div>
                </div>
               
            </div>
        </div>
    );
};

export default MainTable;
